// extracted by mini-css-extract-plugin
export var cardWrapperStyle = "search_jobs_cta_card-module--cardWrapperStyle--LPUMd";
export var ctaWrapperStyle = "search_jobs_cta_card-module--ctaWrapperStyle--BZWRF";